import { Alert, Button, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import axios from "axios";
import * as React from "react";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { ManageNews } from "./manage";

interface NewsState {
    loading: boolean;
    items: any[];
}

interface ToolsWrappedProps {
    activeUser: any;
    activeEnv: any;
    classes: any;
}

class NewsWrapped extends React.Component<ToolsWrappedProps, NewsState> {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            items: [],
        };

        document.title = Helpers.documentTitle("News");
    }
    componentDidMount() {
        this.fetchItems();
    }
    refreshList = () => {
        this.fetchItems();
    }

    fetchItems = () => {
        this.setState({ loading: true }, () => {
            axios.get(`${Config.getInstance.apiUrl}/api/news/list`, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            }).then((result) => {
                this.setState({
                    loading: false,
                    items: result.data.news,
                });
           });
        });
    }

    async exportToServer() {
        try {
            PopupMessage.success("Export started");

            const response = await axios.post(`${Config.getInstance.apiUrl}/api/news/export`, {}, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            PopupMessage.success("Export finished");
        } catch (error) {
            PopupMessage.error("Export failed");
        }
    }

    async deleteNewsArticle(articleId: string) {
        if (confirm("Are you sure?")) {
            try {
                await axios.delete(`${Config.getInstance.apiUrl}/api/news/${articleId}`, {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                });

                PopupMessage.success("Article deleted");
                this.refreshList();
            } catch (error) {
                PopupMessage.error("Couldn't delete article");
            }
        }
    }

    formatChestsToTable = (items) => {
        if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={5}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        if (items.length === 0) {
            return <TableRow key="records_not_found">
                <TableCell colSpan={5}>
                    <Alert severity="info">No News found</Alert>
                </TableCell>
            </TableRow>
        }

        const { classes } = this.props;

        return items.map(item => (
            <TableRow
                key={item.id}
                hover={true}
                className={classes.tableRow}
            >
                <TableCell>{item.title}</TableCell>
                <TableCell>{item.popup ? "Yes" : "No"}</TableCell>
                <TableCell>{item.published ? "Yes" : "No"}</TableCell>
                <TableCell>{new Date(item.created_at).toLocaleDateString()}</TableCell>
                <TableCell>
                    <ManageNews
                        modalTitle="Edit"
                        buttonText="Edit"
                        buttonIcon={true}
                        refreshParent={() => this.refreshList()}
                        item={item}
                    />
                    <span onClick={() => this.deleteNewsArticle(item.id)} style={{ cursor: "pointer", display: "inline-block", marginLeft: 8, color: "red" }}>
                        Delete
                    </span>
                </TableCell>
            </TableRow>
        ));
    }

    formatTableBody(items) {
        return <React.Fragment>
            <Table className="min-table-size">
                <TableHead>
                    <TableRow>
                        <TableCell>Title</TableCell>
                        <TableCell>Popup</TableCell>
                        <TableCell>Published</TableCell>
                        <TableCell>Created At</TableCell>
                        <TableCell style={{ width: 150 }}>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.formatChestsToTable(items)}
                </TableBody>
            </Table>
        </React.Fragment>;
    }

    render() {
        const {classes} = this.props;

        return (
            <div className="contentPadding">
                <Paper className="root" elevation={0}>
                    <div style={{ float: "left", padding: "15px 22px 15px 22px", width: "100%" }}>
                        <div className={classes.title}>
                            <Typography variant="h6" id="tableTitle">
                                News
                            </Typography>
                        </div>
                        <div className={classes.actions}>
                            <div style={{ marginLeft: 15, display: "inline-block" }}>
                                <Button disableElevation onClick={() => this.exportToServer()} variant="contained" size="small">Export to server</Button>
                            </div>
                            <div style={{ marginLeft: 15, display: "inline-block" }}>
                                <ManageNews
                                    buttonText={"Add new"}
                                    modalTitle={"Add new"}
                                    refreshParent={() => this.refreshList()}
                                />
                            </div>
                        </div>
                    </div>

                    <div style={{ float: "left", width: "100%" }}>
                        {this.formatTableBody(this.state.items)}
                    </div>
                </Paper>
            </div>
        );
    }
}

const styles: any = theme => ({
    title: {
        flex: "0 0 auto",
        float: "left",
    },
    actions: {
        color: theme.palette.text.secondary,
        float: "right",
    },
});

export const News = withStyles(styles)(NewsWrapped);
